export default __webpack_public_path__ + "static/media/aws2021practice01-aws-basics-v01.1d376f5c.pdf";